"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
var validatorBradesco_1 = __importDefault(require("./validatorBradesco"));
var validatorItau_1 = __importDefault(require("./validatorItau"));
var validatorSantander_1 = __importDefault(require("./validatorSantander"));
var validatorCaixa_1 = __importDefault(require("./validatorCaixa"));
var validatorBancoDoBrasil_1 = __importDefault(require("./validatorBancoDoBrasil"));
var cleanString_1 = __importDefault(require("../../utils/cleanString"));
function isBankAccountNumberValid() {
  var account = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$bankBranch = _ref.bankBranch,
    bankBranch = _ref$bankBranch === void 0 ? '' : _ref$bankBranch,
    _ref$bankSlug = _ref.bankSlug,
    bankSlug = _ref$bankSlug === void 0 ? '' : _ref$bankSlug,
    _ref$accountType = _ref.accountType,
    accountType = _ref$accountType === void 0 ? '' : _ref$accountType;
  // accountType pode ser 001(corrente), 013 (poupança), 023(simplificada)
  // bank slug pode ser itau, bradesco, caixa, santander
  var bankValidatorsMap = {
    'bradesco': validatorBradesco_1.default,
    'itau': validatorItau_1.default,
    'santander': validatorSantander_1.default,
    'caixa': validatorCaixa_1.default,
    'bb': validatorBancoDoBrasil_1.default
  };
  var safeBankSlug = typeof bankSlug === 'string' ? bankSlug : '';
  var formattedSlug = (0, cleanString_1.default)(safeBankSlug);
  var correctValidator = bankValidatorsMap[formattedSlug];
  if (!correctValidator) return new classes_1.ValidationResult(false, "Valida\xE7\xE3o para banco ".concat(bankSlug, " indispon\xEDvel"));
  var isValid = correctValidator(bankBranch, account, accountType);
  var message = isValid ? '' : 'Conta bancária inválida';
  return new classes_1.ValidationResult(isValid, message);
}
exports.default = new classes_1.Validator(isBankAccountNumberValid);